import { Fragment } from 'react';
import { FEMA_NOT_RECORDED } from '../../config/femaCredentials.config';
import { formatCredentialDate } from '../../utils/credentialState.utils';

/**
 * The non-secret facts of ONE certificate, read-only (FE-11 card :72-74): subject, COG id,
 * serial number, SHA-256 fingerprint, valid from, valid to, last validated. No field carries a
 * password, key bytes or PEM text.
 *
 * @param {{
 *   title: string,
 *   facts: import('types/femaTenant.types').FemaCredentialFacts | null,
 *   cogId?: string | null,
 *   lastValidatedAt?: string | null,
 * }} props
 */
const CredentialFacts = ({ title, facts, cogId = null, lastValidatedAt = null }) => {
  const rows = [
    ['Subject', facts?.subject || FEMA_NOT_RECORDED],
    ['COG id', cogId || FEMA_NOT_RECORDED],
    ['Serial number', facts?.serialNumber || FEMA_NOT_RECORDED],
    ['SHA-256 fingerprint', facts?.sha256 || FEMA_NOT_RECORDED],
    ['Valid from', formatCredentialDate(facts?.notBefore)],
    ['Valid to', formatCredentialDate(facts?.notAfter)],
    ['Last validated', formatCredentialDate(lastValidatedAt)],
  ];

  return (
    <section aria-label={title} className="mb-3">
      <h3 className="h6">{title}</h3>
      <dl className="row mb-0 small">
        {rows.map(([label, value]) => (
          <Fragment key={label}>
            <dt className="col-sm-4">{label}</dt>
            <dd className="col-sm-8 text-break font-monospace">{value}</dd>
          </Fragment>
        ))}
      </dl>
    </section>
  );
};

export default CredentialFacts;
